import React from 'react';
import styles from './emptyListTemplate.scss';
import productsIcon from './productsIcon.png';

function EmptyListTemplate({ icon, message }) {
  return (
    <div className={styles['main-div']}>
      <img src={icon} alt="empty products" />
      <span>{message}</span>
    </div>
  );
}

EmptyListTemplate.defaultProps = {
  icon: productsIcon,
  message: '沒有相關的商品',
};

export default EmptyListTemplate;
